import {Component, EventEmitter, Input, Output} from '@angular/core';
import { FormButtonsComponent } from '../../../helpers/form/form-buttons/form-buttons.component';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { FormInputErrorsComponent } from '../../../helpers/form/form-input-errors/form-input-errors.component';
import { BijbFormDirective } from '../../../helpers/form/directives/bijb-form.directive';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    standalone: true,
    imports: [FormsModule, BijbFormDirective, FormInputErrorsComponent, NgxTrimDirectiveModule, FormButtonsComponent]
})
export class SignupComponent {
  @Input()
  public busy = false;

  @Input()
  public error = '';

  @Output()
  public submitted = new EventEmitter<{
    firstName: string,
    lastName: string,
    emailAddress: string,
    password: string,
  }>();

  @Input()
  public eventName = '';

  public credentials: {
    firstName: string,
    lastName: string,
    emailAddress: string,
    password: string,
  } = {firstName: '', lastName: '', emailAddress: '', password: ''};

  public signup(): void {
    this.submitted.next(this.credentials);
  }
}
